import {createAction} from 'typesafe-actions';
import * as Types from './types';
import {PanelSelections} from '../../../util/selectionmanager';

export const set = createAction(
  '@view/filter/set',
  action => (ref: Types.Ref, filters: Types.Filter) => action({ref, filters})
);

export const selectionsToFilters = createAction(
  '@view/filter/selectionsToFilters',
  action => (ref: Types.Ref, selections: PanelSelections, axes?: string[]) =>
    action({ref, selections, axes})
);

export type ActionType = ReturnType<typeof set | typeof selectionsToFilters>;
